import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
//import { BannerSlider } from '../../models/notification/BannerSlider.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BannerSlider } from '../../models/BannerSlider/BannerSlider-model';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class BannerSliderService {
  private service = "api/Notification"; //Controller Name
  private eventHelperService = "api/BannerSlider"; //Controller Name
  //private roleHelperService = "api/RoleManagement"; //Controller Name
  private brandHelperService = "api/Brand"; //Controller Name
  private venderHelperService = "api/User"; //Controller Name
  private serviceName = 'api/BannerSlider';
  public bannerSliderList: BannerSlider[];

  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  GetBrands() {
    return this.http.get(`${this.brandHelperService}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }
  GetVerders() {
    return this.http.get(`${this.venderHelperService}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  getBannerSlider() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addBannerSlider(bannerSliderModel: BannerSlider) {
    

    return this.http.post(`${this.serviceName}/AddBannerSlider`, bannerSliderModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  updateBannerSlider(bannerSliderModel: BannerSlider) {
    return this.http.post(`${this.serviceName}/UpdateBannerSlider`, bannerSliderModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteBannerSlider(id: string) {
    return this.http.get(`${this.serviceName}/DeleteBannerSlider?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
    //.map((response: Response) => response.json())
    //.catch(this.errorHandler);
  }

  deleteBannerSliderImage(id: string) {
    return this.http.get(`${this.serviceName}/DeleteBannerSliderImage?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
    //.map((response: Response) => response.json())
    //.catch(this.errorHandler);
  }

  getBannerSliderById(bannerSliderId: string) {
    return this.http.get(`${this.serviceName}/GetBannerSlider?id=` + bannerSliderId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })

      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/BannerSlider/BannerSlider.service.ts